// Généré par scripts/bump-version.js — ne pas modifier manuellement
export const APP_VERSION = '1.1.0';
